<template>
	<div>
	<ul class="apply ovw soak soak_1 info">
		<li class="pad">
			<span>单号</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" v-model="model.orderNo" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>订单类型</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" :value="model.orderType == 1 ? '寄存' : '寄提'" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>寄存时间</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" :value="model.createTime.replace('T',' ')" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>操作人</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" :value="model.createUser" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>门店</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" :value="model.deptID_sname" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>备注</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" :value="model.note" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad" style="border-bottom:0">
			<span>清单</span>
		</li>
	</ul>
		<ul class="record_list2">
			<li style="margin-bottom:0">
				<div>
					<div class="product-item" v-for="(item2,index2) in model.items" :key="index2"><img :src="'/userfile/default/picture/' + item2.productID_simage" /><span>{{item2.productID_sname}}</span><h3>{{item2.num}}{{item2.unit}}</h3></div>
				</div>
			</li>
		</ul>
	<ul class="apply ovw soak soak_1 info" v-if="model.createdSign">
		<li class="pad" style="border-bottom:0">
			<span>签字</span>
		</li>
		<li><img style="width:100%" :src="'' + model.createdSign" /></li>
	</ul>
	</div>
</template>

<script>
import querystring from 'querystring';
import {
  OrderInOutDetail
} from "@/api/api.js"
export default {
  data () {
    return {
      model:{orderNo:'',items:[],createTime:''}
    }
  },
  methods:{
  },
  created:function(){
    let that = this;
    let options = querystring.parse(location.search.replace('?', ''));
    OrderInOutDetail({ID:options.id},function(res){
      that.model = res.model;
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.record_list2{
  margin-bottom: 0;
  margin-top:0;
}
</style>



// WEBPACK FOOTER //
// src/wechat/jcjtdetail.vue